import { render, staticRenderFns } from "./ActionCreateBox.vue?vue&type=template&id=189cc8e5&scoped=true&"
import script from "./ActionCreateBox.vue?vue&type=script&lang=js&"
export * from "./ActionCreateBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189cc8e5",
  null
  
)

export default component.exports